/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_ProgressInputs */

const en_client_tab_progress = /** @type {(inputs: Client_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const pl_client_tab_progress = /** @type {(inputs: Client_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postępy`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Client_Tab_ProgressInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const client_tab_progress = /** @type {((inputs?: Client_Tab_ProgressInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_ProgressInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_client_tab_progress(inputs)
	return en_client_tab_progress(inputs)
});